import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle } from '@material-ui/core';
import { connect } from 'react-redux';
import { Button } from '@ipc/ipc-components';
import ListTable from '../../../../../common/list-table/components/ListTable';
import { StyledModalForm } from '../../../../../common/list-table/helpers/formModal.styles';
import { getMrdContactsImpcData, getMrdContactsImpcColumns } from '../../redux/selectors/MrdContactsSelectors';
import TableDefinitions from '../../../../../common/TableDefinitions';

function ContactCopyDialog(props) {
  const [selectedImpc, updateSelectedImpc] = useState('');
  const [tableData, updateTableData] = useState([]);
  const {
    impcData,
    impcColumns,
    isOpen,
    handleConfirm,
    handleCancel,
    targetImpc,
  } = props;
  useEffect(() => {
    updateTableData(impcData.filter((item) => item.impc !== targetImpc));
  }, [impcData, targetImpc]);
  const handleCancelButton = () => {
    updateSelectedImpc('');
    handleCancel();
  };
  const getOnClickOfImpcTable = (state, rowInfo) => {
    if (rowInfo) {
      return {
        style: {
          background: rowInfo.original.impc === selectedImpc ? '#dbffdb' : null,
        },
        onClick: () => {
          updateSelectedImpc(rowInfo.original.impc);
        },
      };
    }
    return {};
  };
  return (
    <Dialog open={isOpen}>
      <DialogTitle id="simple-dialog-title">Copy Contacts</DialogTitle>
      <StyledModalForm>
        <ListTable
          listId={TableDefinitions.MRD_DEVICE_LIST_BY_COUNTRY.id}
          columns={impcColumns}
          data={tableData}
          getTrProps={getOnClickOfImpcTable}
        />
        <div className="after-box">
          <Button className="cancel" onClick={handleCancelButton}>Cancel</Button>
          <Button
            onClick={() => handleConfirm(selectedImpc)}
            className={`primary-button-${selectedImpc === ''} action`}
            disabled={selectedImpc === ''}
          >
            Confirm
          </Button>
        </div>
      </StyledModalForm>
    </Dialog>
  );
}
function mapStateToProps(state) {
  return {
    impcData: getMrdContactsImpcData(state),
    impcColumns: getMrdContactsImpcColumns(state),
  };
}
ContactCopyDialog.propTypes = {
  impcData: PropTypes.arrayOf(PropTypes.object),
  impcColumns: PropTypes.arrayOf(PropTypes.object),
  isOpen: PropTypes.bool,
  handleConfirm: PropTypes.func,
  handleCancel: PropTypes.func,
  targetImpc: PropTypes.string,
};
export default connect(mapStateToProps)(ContactCopyDialog);
